import openingHour from "utils/opening_hours"
import dayjs from "config/dayjs"
import _ from "lodash"
import relativeTime from "dayjs/plugin/relativeTime"
import isToday from "dayjs/plugin/isToday"
dayjs.extend(relativeTime)
dayjs.extend(isToday)

export const days = ["mo", "tu", "we", "th", "fr", "sa", "su"]

const parseToDate = (hours) => {
  if (!hours) return null
  const [hour, minute, second] = hours.split(":").map(_.toNumber)
  return dayjs()
    .set("hour", hour)
    .set("minute", minute || 0)
    .set("second", second || 0)
}

const convertToTimestampString = (timesArr) => {
  return timesArr?.format("HH:mm")
}

export const findCurrentDateName = () => {
  return days[dayjs().get("day")]
}

export const parseOpeningHours = (osmDate) => {
  try {
    const hoursArr = openingHour.compute(osmDate)
    if (_.isNull(hoursArr)) return null
    return days.reduce(
      (acc, day) => ({
        [day]: hoursArr[day]?.map((hour) => parseToDate(hour)) || null,
        ...acc,
      }),
      {}
    )
  } catch (error) {
    return null
  }
}

export const findTodayOperatingTime = (hoursArr) => {
  const currentTime = dayjs()
  const currentDateIdx = currentTime.get("day")
  const currentDay = days[currentDateIdx]

  // Check if current time is before today's opening
  if (_.get(hoursArr, currentDay)) {
    return {
      day: _.capitalize(currentDay),
      open: convertToTimestampString(hoursArr[currentDay][0]),
      close: convertToTimestampString(hoursArr[currentDay][1]),
    }
  }
}

export const findNextOpeningTime = (hoursArr) => {
  const currentTime = dayjs()
  const currentDateIdx = currentTime.get("day")
  const currentDay = days[currentDateIdx]
  const currentDayHoursArr = _.get(hoursArr, currentDay)
  // Check if current time is before today's opening
  if (currentDayHoursArr && currentTime.isBefore(currentDayHoursArr[0])) {
    return {
      day: _.capitalize(currentDay),
      open: convertToTimestampString(currentDayHoursArr[0]),
    }
  }

  const newDays = days
    .slice(currentDateIdx, days.length)
    .concat(days.slice(0, currentDateIdx))

  const nextOpenDay = newDays.find((day) => _.get(hoursArr, day))
  // Next Opening Day
  return {
    day: _.capitalize(nextOpenDay),
    open: convertToTimestampString(hoursArr[nextOpenDay][0]),
  }
}

export const isOpen = (hoursArr) => {
  const currentTime = dayjs()
  const dayIdx = currentTime.get("day")

  const dateShortName = days[dayIdx]
  //   If not available in osm that day it is closed
  if (!_.get(hoursArr, dateShortName)) {
    return false
  }
  const [openOn, closeOn] = hoursArr[dateShortName]

  return dayjs().isBefore(closeOn) && dayjs().isAfter(openOn)
}

export const getDurationDate = (startDate, endDate) => {
  if (
    endDate.year() > startDate.year() ||
    endDate.month() > startDate.month()
  ) {
    return `${startDate.format("DD MMM")} - ${endDate.format("DD MMM")}`
  }
  return `${startDate.format("DD")} - ${endDate.format("DD MMM")}`
}

export const getDisplayDateTime = (startDate, endDate) => {
  return dayjs(endDate).isToday()
    ? dayjs().isAfter(startDate)
      ? `Ending ${dayjs().to(dayjs(endDate))}`
      : `Starting ${dayjs(startDate).fromNow()}`
    : getDurationDate(startDate, endDate)
}

export const getCurrentDate = () => {
  return dayjs().toISOString()
}

export const isBeforeDate = (mainDate, comparingDate) => {
  return dayjs(mainDate).isBefore(comparingDate)
}

export const addDurationToDate = (dateISOString, milliseconds) => {
  const currentTime = dayjs(dateISOString)
  const expireTime = currentTime.add(milliseconds, "millisecond")
  return expireTime.toISOString()
}

export const calculateDateDifference = (
  mainDateISOString,
  comparisonDateISOString,
  units = "milliseconds"
) => {
  // Define two date objects
  const mainDate = dayjs(mainDateISOString)
  const comparisonDate = dayjs(comparisonDateISOString)

  // Calculate the difference between the two dates
  return comparisonDate.diff(mainDate, units)
}
